import { Column, GroupColumn } from '../types/grid';
import { Signal } from '@angular/core';
import { Formatter, Translation } from '@softline/ui-core';
import { GridDataSource } from '@softapps/core';
import { EntityColumnRef, GridRef, GroupColumnRef } from '../types/refs';

export interface GroupColumnOptions<TRow extends object> {
  header: Signal<Translation>;
  headerClass?: string;
  hide?: boolean;
}

export function groupColumn<TRow extends object>(ref: GridRef<TRow> | GroupColumnRef<TRow> | EntityColumnRef<TRow>,
                                                 options: GroupColumnOptions<TRow>,
                                                 factory: (ref: GroupColumnRef<TRow>) => void): GroupColumn<TRow> {

  const groupRef: GroupColumnRef<TRow> = new GroupColumnRef<TRow>(ref.formatter);
  factory(groupRef);
  const groupColumn: GroupColumn<TRow> = {
    ...options,
    type: 'group',
    children: groupRef.columns,
  }
  ref.createColumn(groupColumn)
  return groupColumn;
}
